/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiClientDetails,
    ApiClientDetailsFromJSON,
    ApiClientDetailsToJSON,
    ApiClientDetailsPage,
    ApiClientDetailsPageFromJSON,
    ApiClientDetailsPageToJSON,
} from '../models';

export interface DeleteClientDetailsRequest {
    clientId: string;
}

/**
 * 
 */
export class OauthApi extends runtime.BaseAPI {

    /**
     * Creates client details
     */
    async createClientDetailsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiClientDetails>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/oauth/clients`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiClientDetailsFromJSON(jsonValue));
    }

    /**
     * Creates client details
     */
    async createClientDetails(initOverrides?: RequestInit): Promise<ApiClientDetails> {
        const response = await this.createClientDetailsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Deletes client details
     */
    async deleteClientDetailsRaw(requestParameters: DeleteClientDetailsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiClientDetails>> {
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling deleteClientDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/oauth/clients/{clientId}`.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiClientDetailsFromJSON(jsonValue));
    }

    /**
     * Deletes client details
     */
    async deleteClientDetails(requestParameters: DeleteClientDetailsRequest, initOverrides?: RequestInit): Promise<ApiClientDetails> {
        const response = await this.deleteClientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets client details
     */
    async getClientDetailsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiClientDetailsPage>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/oauth/clients`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiClientDetailsPageFromJSON(jsonValue));
    }

    /**
     * Gets client details
     */
    async getClientDetails(initOverrides?: RequestInit): Promise<ApiClientDetailsPage> {
        const response = await this.getClientDetailsRaw(initOverrides);
        return await response.value();
    }

}
